import CategoryIcon from '@mui/icons-material/Category';

interface Props {
  size: number;
  color: string;
}

export default function CategoriesIcon({ size, color }: Props) {
  return (
    <CategoryIcon sx={{ fontSize: size, color }} />
  )
}
